<template>
  <div class="home">
    <LoaderComponent v-show="loading || paying || achPaying" />
    <HeaderView />

    <section class="new-payment-page-main-sec agency-design-grid-right">
      <div class="desktop-responsive-main-sec">


        <div class="new-payment-layout">
          <!-- Left: Order Summary -->
          <div class="order-summary-panel">
            <div class="back-to-order">
          <button type="button" class="back-btn" @click="goBackToOrder">
            <i class="fas fa-arrow-left"></i>
            {{ draftCheckoutMode ? "Back To Draft Orders" : "Back To Order" }}
          </button>
        </div>
            <div class="order-summary-header">
                <h2 class="text-heading">Order Summary</h2>
                <p class="step-indicator">Step 2/2</p>
                
              <div class="total-links-pill">
                <span>Total {{ totalLinks <= 1 ? "Link" : "Links" }}: </span>
                <strong>{{ totalLinks }}</strong>
              </div>
            </div>

            <div class="invoice-draft-summary-list" v-if="draftCheckoutMode">
              <div
                class="invoice-draft-summary-card"
                v-for="(row, index) in invoiceSummaryRows"
                :key="'invoice-draft-' + index"
              >
                <div class="invoice-draft-summary-main">
                  <div class="row-label">Draft #{{ row.id }}</div>
                  <div class="row-value">{{ row.title }}</div>
                </div>
                <div class="invoice-draft-summary-meta">
                  <span>{{ row.links }} {{ row.links === 1 ? "Link" : "Links" }}</span>
                  <strong>{{ numberFormat(row.amount, "currency") }}</strong>
                </div>
              </div>
            </div>

            <div class="link-breakdown-heading" v-if="!draftCheckoutMode">
              <span>Link Breakdown</span>
            </div>

            <div class="order-summary-list" v-if="isMediaLinksSummaryFlow && !draftCheckoutMode">
              <div
                class="link-card media-link-simple-card"
                v-for="(link, i) in links"
                :key="link.id || i"
              >
                <div class="link-number-pill">
                  <span>{{ i + 1 }}</span>
                </div>
                <div class="link-main-item">
                  <div class="row-label">Media Site</div>
                  <div class="row-value">{{ getMediaSiteName(link) }}</div>
                </div>
                <div class="link-main-item">
                  <div class="row-label">Destination URL</div>
                  <div class="row-value">{{ getDestinationUrl(link) }}</div>
                </div>
                <div class="link-header-right">
                  <span class="link-price">{{ numberFormat(getLinkTotal(link), "currency") }}</span>
                </div>
              </div>
            </div>

            <div class="order-summary-list" v-else-if="!draftCheckoutMode">
              <!-- Link cards with collapse/expand -->
                <div
                  class="link-card"
                  v-for="(link, i) in links"
                  :key="link.id"
                >
                  <div class="link-card-header" @click="toggleLink(link.id)">
                    <div class="link-number-pill">
                      <span>{{ (i+1) }}</span>
                    </div>

                    <div class="link-header-main">
                      <div class="link-top-row">
                        <span class="link-metric-pill">{{ formatMetricValue(link) }}</span>
                        <span class="link-separator">|</span>
                        <span class="link-domain">{{ link?.url || '—' }}</span>
                      </div>
                      <div class="link-header-meta">{{ (link?.addons || []).length }} {{ (link?.addons || []).length <= 1 ? "Add-On" : "Add-Ons" }}</div>
                    </div>

                    <div class="link-header-right">
                      <span class="link-price">{{ numberFormat(getLinkTotal(link), "currency") }}</span>
                      <i
                        class="fas"
                        :class="link.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"
                      ></i>
                    </div>
                  </div>

                  <div
                    class="link-card-body"
                    v-show="link.isOpen"
                  >
                    <div class="link-main-row">
                      <div class="link-main-item">
                        <div class="row-label">URL</div>
                        <div class="row-value">{{ link?.url || '—' }}</div>
                      </div>
                      <div class="link-main-item">
                        <div class="row-label">Anchor</div>
                        <div class="row-value">{{ link?.text || '—' }}</div>
                      </div>
                      <div class="link-main-item">
                        <div class="row-label">Metric</div>
                        <div class="row-value">{{ link?.product?.name?.startsWith('DR') ? 'DR' : 'DA' }}</div>
                      </div>
                      <div class="link-main-item">
                        <div class="row-label">{{ getMetric(link) === 'DR' ? 'DR Value' : 'DA Value' }}</div>
                        <div class="row-value">{{ formatMetricValue(link) }}</div>
                      </div>
                      <div class="link-main-item">
                        <div class="row-label">Industry</div>
                        <div class="row-value">{{ link?.primary_category?.name || '—' }}</div>
                      </div>
                    </div>

                    <div class="addons-box" v-if="link?.addons?.length > 0">
                      <div class="addons-title">Add-Ons</div>
                      <div class="addons-grid-row">
                        
                      <!-- Minimum Traffic -->
                      <div class="addon-col" v-if="pickAddon(link, 'Minimum Traffic')">
                        <div class="addon-label">
                          Traffic: {{ pickAddon(link, 'Minimum Traffic')?.name }}
                        </div>
                        <div class="addon-price">
                          +{{ numberFormat(pickAddon(link, 'Minimum Traffic')?.cost || 0, "currency") }}
                        </div>
                      </div>

                      <!-- Country (addon group; option name e.g. UK, USA from product) -->
                      <div class="addon-col" v-if="pickAddon(link, 'Country')">
                        <div class="addon-label">
                          Country: {{ pickAddon(link, 'Country')?.name }}
                        </div>
                        <div class="addon-price">
                          +{{ numberFormat(pickAddon(link, 'Country')?.cost || 0, "currency") }}
                        </div>
                      </div>

                      <!-- Traffic Stability -->
                      <div class="addon-col" v-if="pickAddon(link, 'Traffic Stability')">
                        <div class="addon-label">
                          Traffic Stable: {{ formatTrafficStability(pickAddon(link, 'Traffic Stability')?.name) }}
                        </div>
                        <div class="addon-price">
                          +{{ numberFormat(pickAddon(link, 'Traffic Stability')?.cost || 0, "currency") }}
                        </div>
                      </div>

                      <!-- Spam Score -->
                      <div class="addon-col" v-if="pickAddon(link, 'Spam Score')">
                        <div class="addon-label">
                          <!-- Spam {{ formatLessThanAddonName(pickAddon(link, 'Spam Score')?.name) }} -->
                          Spam: {{ pickAddon(link, 'Spam Score')?.name }}
                        </div>
                        <div class="addon-price">
                          +{{ numberFormat(pickAddon(link, 'Spam Score')?.cost || 0, "currency") }}
                        </div>
                      </div>

                      <!-- RD:LD Ratio -->
                      <div class="addon-col" v-if="pickAddon(link, 'RD:LD Ratio')">
                        <div class="addon-label">
                          RD:LD {{ pickAddon(link, 'RD:LD Ratio')?.name }}
                        </div>
                        <div class="addon-price">
                          +{{ numberFormat(pickAddon(link, 'RD:LD Ratio')?.cost || 0, "currency") }}
                        </div>
                      </div>

                        <!-- CF:TF Ratio -->
                        <div class="addon-col" v-if="pickAddon(link, 'CF:TF Ratio') && Number(pickAddon(link, 'CF:TF Ratio')?.cost || 0) > 0">
                          <div class="addon-label">
                            CF:TF {{ pickAddon(link, 'CF:TF Ratio')?.name }}
                          </div>
                          <div class="addon-price">
                            +{{ numberFormat(pickAddon(link, 'CF:TF Ratio')?.cost || 0, "currency") }}
                          </div>
                        </div>

                      <!-- Content Approval -->
                      <div class="addon-col" v-if="pickAddon(link, 'Content Approval')">
                        <div class="addon-label">Content Approval</div>
                        <div class="addon-price">
                          +{{ numberFormat(pickAddon(link, 'Content Approval')?.cost || 0, "currency") }}
                        </div>
                      </div>

                      <!-- Niche Purity -->
                      <div class="addon-col" v-if="pickAddon(link, 'Niche Purity')">
                        <div class="addon-label">Niche Purity</div>
                        <div class="addon-price">
                          +{{ numberFormat(pickAddon(link, 'Niche Purity')?.cost || 0, "currency") }}
                        </div>
                      </div>
                    
                      </div>
                    </div>

                    <div class="link-footer-row">
                      <div class="footer-col">
                        <span class="footer-label">Base Price</span>
                        <span class="footer-value">
                          {{ numberFormat(getLinkBasePrice(link), "currency") }}
                        </span>
                      </div>
                      <div class="footer-col">
                        <span class="footer-label">Add-Ons</span>
                        <span class="footer-value">
                          +{{ numberFormat(getLinkAddonsTotal(link), "currency") }}
                        </span>
                      </div>
                      <div class="footer-col">
                        <span class="footer-label">Total</span>
                        <span class="footer-value">
                          {{ numberFormat(getLinkTotal(link), "currency") }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <div class="coupon-section" v-if="!isMediaLinksSummaryFlow && !draftCheckoutMode">
              <label>Coupon Code</label>
              <div class="coupon-input-row">
                <input v-model="coupon" type="text" placeholder="Enter Code" />
                <button type="button" class="btn-apply" @click="applyCoupon('m')">Apply</button>
              </div>
              <div
                class="error-msg"
                v-if="errors.coupon"
                style="margin-top: 8px; color: #d93025; font-size: 13px;"
              >
                <strong>{{ errors.coupon }}</strong>
              </div>
            </div>
            <div class="pricing-summary-heading">
              <span>Pricing Summary</span>
            </div>
            <div class="pricing-summary">
             
              <div class="summary-row">
                <span>Subtotal ({{ totalLinks }} {{ totalLinks <= 1 ? "Link" : "Links" }})</span>
                <span>{{ numberFormat(sub_total, "currency") }}</span>
              </div>
              <div class="summary-row" v-if="!isMediaLinksSummaryFlow && !draftCheckoutMode">
                <span>Total Add-Ons</span>
                <span>{{ numberFormat(addon_total, "currency") }}</span>
              </div>
              <div
                v-if="combinedDiscount > 0"
                class="summary-row discount"
              >
                <span>Discount ({{ discountPercentLabel }}%)</span>
                <span>(-{{ numberFormat(combinedDiscount, "currency") }})</span>
              </div>
              <div class="summary-row grand-total">
                <span>Total</span>
                <span>USD {{ numberFormat(payableTotal, "currency") }}</span>
              </div>
            </div>
          </div>

          <!-- Right: Secure Checkout -->
          <div class="secure-checkout-panel" v-if="!showPaymentReviewPanel">
            <div class="secure-checkout-header">
              <div class="title-with-icon">
                <i class="fas fa-lock"></i>
                <h3>Secure Checkout</h3>
              </div>
            </div>

            <div class="billing-details" v-if="showBillingSection">
              <h4>Billing Details</h4>
              <div class="form-grid" v-if="selectedPaymentMethod === 'ach'">
                <div class="form-group half">
                  <label>First Name</label>
                  <input type="text" v-model="form.first_name" placeholder="First Name" autocomplete="given-name" />
                  <div v-if="fieldErrors.first_name" class="inline-error">{{ fieldErrors.first_name }}</div>
                </div>
                <div class="form-group half">
                  <label>Last Name</label>
                  <input type="text" v-model="form.last_name" placeholder="Last Name" autocomplete="family-name" />
                  <div v-if="fieldErrors.last_name" class="inline-error">{{ fieldErrors.last_name }}</div>
                </div>
                <div class="form-group full">
                  <label>Email</label>
                  <input type="email" v-model="form.email" placeholder="Email" autocomplete="email" />
                  <div v-if="fieldErrors.email" class="inline-error">{{ fieldErrors.email }}</div>
                </div>
              </div>
              <div class="form-grid" v-else>
                <div class="form-group full">
                  <label>Address</label>
                  <input type="text" v-model="form.address" placeholder="Address" />
                  <div v-if="fieldErrors.address" class="inline-error">{{ fieldErrors.address }}</div>
                </div>
                <div class="form-group half">
                  <label>Country</label>
                  <select v-model="form.country" @change="getStates(form.country)">
                    <option :value="null">Select Country</option>
                    <option
                      v-for="country in countries"
                      :key="country.id"
                      :value="country.id"
                    >
                      {{ country.name }}
                    </option>
                  </select>
                  <div v-if="fieldErrors.country" class="inline-error">{{ fieldErrors.country }}</div>
                </div>
                <div class="form-group half">
                  <label>State</label>
                  <select v-model="form.state">
                    <option :value="null">Select State</option>
                    <option
                      v-for="state in states"
                      :key="state.id"
                      :value="state.id"
                    >
                      {{ state.name }}
                    </option>
                  </select>
                  <div v-if="fieldErrors.state" class="inline-error">{{ fieldErrors.state }}</div>
                </div>
                <div class="form-group half">
                  <label>City</label>
                  <input type="text" v-model="form.city" placeholder="City" />
                  <div v-if="fieldErrors.city" class="inline-error">{{ fieldErrors.city }}</div>
                </div>
                <div class="form-group half">
                  <label>Zip Code</label>
                  <input type="text" v-model="form.zipCode" placeholder="Enter Zip Code" />
                  <div v-if="fieldErrors.zipCode" class="inline-error">{{ fieldErrors.zipCode }}</div>
                </div>
                <div
                  v-if="selectedPaymentMethod === 'card' && selectedCardTab === 'new'"
                  class="form-group full profile-address-row"
                >
                  <label class="save-card-checkbox">
                    <input
                      type="checkbox"
                      v-model="useProfileAddressChecked"
                      @change="getProfileAddress"
                    />
                    <span>Use Profile Address</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="payment-method-section" :class="{ 'no-billing': !showBillingSection }">
              <h4>Select Payment Method</h4>
              <div class="payment-tabs">
                <div class="payment-tab-item">
                  <span class="payment-tab-label">Credit/Debit card</span>
                  <button
                    type="button"
                    class="tab"
                    :class="{ active: selectedPaymentMethod === 'card' }"
                    @click="cardListFunction(1)"
                  >
                    <i class="fas fa-check" v-if="selectedPaymentMethod === 'card'"></i>
                    <span class="radio-circle" v-if="selectedPaymentMethod !== 'card'"></span>
                    <img src="@/assets/common/images/cards.png" alt="Cards" />
                  </button>
                </div>
                <div class="payment-tab-item">
                  <span class="payment-tab-label">Pay via Paypal</span>
                  <button
                    type="button"
                    class="tab"
                    :class="{ active: selectedPaymentMethod === 'paypal' }"
                    @click="cardListFunction(4)"
                  >
                    <i class="fas fa-check" v-if="selectedPaymentMethod === 'paypal'"></i>
                    <span class="radio-circle" v-if="selectedPaymentMethod !== 'paypal'"></span>
                    <img src="@/assets/common/images/pp-logo-150px.png" alt="PayPal" />
                  </button>
                </div>
                <div class="payment-tab-item">
                  <span class="payment-tab-label">ACH Payment</span>
                  <button
                    type="button"
                    class="tab"
                    :class="{ active: selectedPaymentMethod === 'ach' }"
                    @click="cardListFunction(5)"
                  >
                    <i class="fas fa-check" v-if="selectedPaymentMethod === 'ach'"></i>
                    <span class="radio-circle" v-if="selectedPaymentMethod !== 'ach'"></span>
                    <span class="ach-tab-text">
                      <img class="ach-tab-icon" src="@/assets/common/images/ach-payment.png" alt="" />
                      <span>ACH</span>
                      <em>Save 1%</em>
                    </span>
                  </button>
                </div>
                <div class="payment-tab-item">
                  <span class="payment-tab-label">Pay from Wallet</span>
                  <button
                    type="button"
                    class="tab"
                    :class="{ active: selectedPaymentMethod === 'wallet' }"
                    @click="cardListFunction(3)"
                  >
                    <i class="fas fa-check" v-if="selectedPaymentMethod === 'wallet'"></i>
                    <span class="radio-circle" v-if="selectedPaymentMethod !== 'wallet'"></span>
                    <i class="fas fa-wallet"></i>
                    <span>My Wallet</span>
                  </button>
                </div>
              </div>

              <div
                class="card-toggle"
                v-if="selectedPaymentMethod === 'card'"
              >
                <button
                  type="button"
                  class="toggle-btn"
                  :class="{ active: selectedCardTab === 'new' }"
                  @click="cardFunction(1)"
                >
                  New Card
                </button>
                <button
                  type="button"
                  class="toggle-btn"
                  :class="{ active: selectedCardTab === 'saved' }"
                  @click="cardFunction(2)"
                >
                  Saved Card
                </button>
              </div>
              
            </div>

            <div
              class="card-details-section"
              v-if="selectedPaymentMethod === 'card' && selectedCardTab === 'new'"
            >
              <div class="form-group card-details-header">
                <label>Card Details</label>
                <label class="save-card-checkbox">
                  <input type="checkbox" v-model="saveCheck" true-value="save_card" false-value="no" />
                  <span>Save This Card</span>
                </label>
              </div>

              <div class="card-row card-number-row">
                <!-- <label>Card Number</label> -->
                <div class="card-number-group-row">
                  <div class="form-group card-number-group">
                    <div id="card-element"></div>
                    <div id="card-errors" style="color: #d93025; margin-top: 6px; font-size: 12px;"></div>
                </div>
                </div>
              
              </div>

              <div class="card-row name-row">
                
                <div class="form-group">
                  <label>First Name</label>
                  <input type="text" v-model="form.first_name" placeholder="First Name" />
                  <div v-if="fieldErrors.first_name" class="inline-error">{{ fieldErrors.first_name }}</div>
                </div>
                <div class="form-group">
                  <label>Last Name</label>
                  <input type="text" v-model="form.last_name" placeholder="Last Name" />
                  <div v-if="fieldErrors.last_name" class="inline-error">{{ fieldErrors.last_name }}</div>
                </div>
              </div>
            </div>
            <div class="pay-button-wrapper"  v-if="selectedPaymentMethod === 'card' && selectedCardTab === 'new'">
              <button type="button" class="btn-pay" :disabled="payButtonDisabled" @click="submitPayment">
                Pay USD {{ numberFormat(payableTotal, "currency") }} Securely
              </button>
            </div>
            <div
              class="saved-card-section"
              v-if="selectedPaymentMethod === 'card' && selectedCardTab === 'saved'"
            >
              <div class="saved-card-list">
                <label
                  class="saved-card-item"
                  v-for="card in normalizedSavedCards"
                  :key="card.id"
                  :class="{ active: String(selectedSavedCardId) === String(card.id) }"
                >
                  <input
                    type="radio"
                    name="saved-card"
                    v-model="selectedSavedCardId"
                    :value="card.id"
                    @change="getSelectedCardDetail(card.id)"
                  />

                  <span class="saved-radio">
                    <i class="fas fa-check"></i>
                  </span>

                  <div class="saved-card-body">
                    <img
                      src="@/assets/common/images/chip.svg"
                      alt="Chip"
                    />
                    <div class="saved-card-text">
                      <span class="saved-card-mask">**** **** **** {{ card.last4 || '****' }}</span>
                      <!-- <span class="saved-card-meta"
                        >Expiry {{ card.exp_month || 'MM' }}/{{ card.exp_year || 'YY' }}</span
                      > -->
                    </div>
                  </div>

                </label>
              </div>
              <div v-if="!normalizedSavedCards.length" class="inline-error" style="color:#666;">
                No saved cards found.
              </div>
              <div v-if="fieldErrors.saved_card" class="inline-error">{{ fieldErrors.saved_card }}</div>
            </div>
            <div class="pay-button-wrapper" v-if="selectedPaymentMethod === 'card' && selectedCardTab === 'saved'">
              <button type="button" class="btn-pay" :disabled="payButtonDisabled" @click="submitPayment">
                Pay USD {{ numberFormat(payableTotal, "currency") }} Securely
              </button>
            </div>

            <div
              class="wallet-summary-section"
              v-if="selectedPaymentMethod === 'wallet'"
            >
              <p class="wallet-text">
                Available Balance: <strong>{{ numberFormat(userData.balance, "currency") }}</strong>
              </p>
              <p class="paypal-text" v-if="showWalletInsufficient">
                Insufficient Balance.
                <span
                  v-if="userData.role === 'Agency'"
                  v-b-modal.modal-box-4
                  style="text-decoration: underline; cursor: pointer; margin-left: 6px;"
                >
                  Add Balance
                </span>
              </p>
              <!-- <p class="wallet-subtext">Use wallet balance to pay for this order.</p> -->
              <div class="pay-button-wrapper" v-if="!showWalletInsufficient">
                <button type="button" class="btn-pay" :disabled="payButtonDisabled" @click="submitPayment">
                  Pay with Wallet (USD {{ numberFormat(payableTotal, "currency") }})
                </button>
              </div>
            </div>

            <div
              class="paypal-summary-section"
              v-if="selectedPaymentMethod === 'paypal'"
            >
              <p class="paypal-text">
                You will be redirected to PayPal to complete this purchase.
              </p>
              <div
                id="paypal-button-container"
                :class="{ active: paypalShow }"
                style="margin-top: 12px;"
              ></div>
              <div class="pay-button-wrapper" v-if="!paypalShow">
                <button type="button" class="btn-pay" @click="cardListFunction(4)">
                  Continue with PayPal (USD {{ numberFormat(payableTotal, "currency") }})
                </button>
              </div>
            </div>

            <div class="order-ach-panel" v-if="selectedPaymentMethod === 'ach'">
              <p class="order-ach-copy">
                Pay from a US bank account. The transfer usually clears in 2–5 business days. Your order stays on hold until the payment is confirmed.
              </p>
              <div
                id="order-ach-element"
                class="order-ach-element"
                :class="{ 'is-loading': achLoading }"
              ></div>
              <p v-if="achLoading" class="order-ach-loading">Loading bank checkout…</p>
              <div v-if="achError" class="inline-error">{{ achError }}</div>
              <div class="pay-button-wrapper">
                <button type="button" class="btn-pay" :disabled="payButtonDisabled" @click="submitAchPayment">
                  Pay USD {{ numberFormat(payableTotal, "currency") }} with ACH
                </button>
              </div>
            </div>

          </div>

          <div class="payment-review-panel" v-if="showPaymentReviewPanel">
            <div class="review-panel-inner">
              <div class="review-icon">
                  <img src="@/assets/common/images/Review-your-order-shield-check-1.png" alt="Review icon" />
                </div>
              <h3>You're Almost Done.</h3>
              <p>
                Review your order details on the left and proceed to secure payment when you're ready.
              </p>

              <div class="review-total-card">
                <span class="total-label">Order Total</span>
                <strong>{{ numberFormat(payableTotal, "currency") }}</strong>
                <span class="total-currency">USD</span>
              </div>

              <button type="button" class="btn-proceed-payment" @click="proceedFromOrderReview">
                Proceed To Payment
              </button>

              <div class="secure-note">
                <i class="fas fa-lock"></i>
                <span>Payments are securely processed</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-list">
          <b-modal
            id="modal-box-4"
            centered
            title="Add Balance"
            :no-close-on-backdrop="true"
            v-if="userData.role === 'Agency'"
          >
            <AddBalanceComponent
              :countries="countries"
              :existingCards="existingCardList"
              @success="showAddBalance"
            />
          </b-modal>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderView from "@/components/layout/HeaderComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import AddBalanceComponent from "@/components/AddBalanceComponent.vue";
import { numberFormat } from "@/prod.js";
import LZString from "lz-string";
import url from "@/prod.js";
import { pushAnalyticsUserId } from "@/services/analyticsUserId.js";
import { stackedDiscount } from "@/utils/achDiscount.js";
import achCheckout from "@/mixins/achCheckout.js";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "NewPaymentPage",
  mixins: [achCheckout],
  components: {
    HeaderView,
    LoaderComponent,
    AddBalanceComponent,
  },
  data() {
    return {
      numberFormat,
      LZString,
      stripeKey: url.stripeKey,
      loading: true,
      paying: false,
      editedOrder: false,
      linkIds: [],
      editedOrderId: "",
      newPrice: 0,
      oldPrice: 0,
      groupedLinks: [],
      editOrderPP: false,
      links: [],
      draft_order_id: "",
      summary: {
        order_title: "",
      },
      da_20_count: 0,
      da_20_total: 0,
      da_30_count: 0,
      da_30_total: 0,
      da_40_count: 0,
      da_40_total: 0,
      da_50_count: 0,
      da_50_total: 0,
      da_60_count: 0,
      da_60_total: 0,
      link_total: 0,
      addon_total: 0,
      addon_count: 0,
      sub_total: 0,
      backend_sub_total: 0,
      discount: 0,
      order_total: 0,
      opportunity_ids: null,
      opportunityOrder: false,
      summaryPaymentData: null,
      packageOrder: false,
      packageName: "",
      packageId: "",
      packagePrice: 0,
      packageLinks: 0,
      coupon: "",
      referral: false,
      errors: {},
      fieldErrors: {
        address: "",
        country: "",
        state: "",
        city: "",
        zipCode: "",
        first_name: "",
        last_name: "",
        email: "",
        saved_card: "",
      },
      form: {
        couponCode: "",
        address: "",
        country: null,
        state: null,
        city: "",
        zipCode: "",
        cardNumber: "",
        cardMM: "",
        cardYY: "",
        cardCVC: "",
        first_name: "",
        last_name: "",
        email: "",
      },
      orderMedium: "direct",
      orderSource: "direct",
      orderCampaign: "",
      paymentOption: "card",
      detailBox: false,
      walletBox: false,
      payPalBox: false,
      detailBoxBalance: true,
      saveCheck: "no",
      existingCard: "no",
      method: "new_card",
      card: "",
      paypal: {
        sandbox: url.paypalKey,
        production: "",
      },
      appStatus: url.appStatus,
      mainProducts: {},
      paypalShow: false,
      payment_id: "",
      paymentIntent_id: "",
      paymentHistory_id: "",
      paymentMethod_id: "",
      cardLast4: "",
      stripeElement: null,
      stripCard: null,
      stripeScriptPromise: null,
      existingCardList: [],
      countries: [],
      states: [],
      selectedPaymentMethod: 'card',
      selectedCardTab: 'new',
      showPaymentReviewPanel: false,
      selectedSavedCardId: null,
      useProfileAddressChecked: false,
      isMediaLinksSummaryFlow: false,
      draftCheckoutMode: false,
      draftCheckoutToken: "",
      draftCheckoutIds: [],
      draftCheckoutItems: [],
      draftCheckouts: {},
    }
  },
  computed: {
    invoiceSummaryRows() {
      return (this.draftCheckoutItems || []).map((item) => {
        const draftId = item?.draft_order_id ? String(item.draft_order_id) : "—";
        const title = String(item?.description || item?.title || "Draft Order").trim() || "Draft Order";
        const qty = Math.max(Number(item?.qty) || 0, 0);

        return {
          id: draftId,
          title,
          links: qty,
          amount: Number(item?.amount ?? item?.line_total) || 0,
        };
      });
    },
    userData() {
      const data = this.$store?.getters?.["Auth/getUser"] || {};
      return {
        role: data.role || "",
        balance: Number(data.balance) || 0,
        is_wallet: data.is_wallet,
        is_save_card: data.is_save_card,
        is_add_card: data.is_add_card,
        referred_by: data.referred_by,
        email: data.email || "",
      };
    },
    orderBaseAmount() {
      return (Number(this.sub_total) || 0) + (Number(this.addon_total) || 0);
    },
    couponDiscountAmount() {
      return Number(this.discount) || 0;
    },
    discountQuote() {
      return stackedDiscount({
        base: this.orderBaseAmount,
        couponAmount: this.couponDiscountAmount,
        achSelected: this.selectedPaymentMethod === "ach",
      });
    },
    achDiscountAmount() {
      return this.discountQuote.achAmount;
    },
    combinedDiscount() {
      return this.discountQuote.totalAmount;
    },
    discountPercentLabel() {
      return this.discountQuote.percentLabel;
    },
    totalLinks() {
      if (this.draftCheckoutMode) {
        return (this.draftCheckoutItems || []).reduce(
          (sum, item) => sum + Math.max(Number(item?.qty) || 0, 0),
          0
        );
      }
      return (this.links || []).length;
    },
    showBillingSection() {
      return this.selectedPaymentMethod === "card" || this.selectedPaymentMethod === "ach";
    },
    normalizedSavedCards() {
      return (this.existingCardList || []).map((card) => ({
        id:
          card.id ||
          card.card_id ||
          card.payment_method_id ||
          card.stripe_payment_method_id ||
          card.last4 ||
          card.last_4,
        last4: card.last4 || card.last_4 || card.card_last4 || "",
        exp_month: card.exp_month || card.expiry_month || "",
        exp_year: card.exp_year || card.expiry_year || "",
      }));
    },
    payableTotal() {
      return this.discountQuote.payable;
    },
    showWalletInsufficient() {
      return Number(this.userData.balance) < Number(this.payableTotal);
    },
    payButtonDisabled() {
      return this.loading || this.paying || this.achPaying;
    },
  },
  methods: {
    pushAnalyticsUserId,
    resolvePaymentHistoryId(payload) {
      const pick = (val) => {
        const id = Number(val);
        return Number.isFinite(id) && id > 0 ? id : 0;
      };

      const direct =
        pick(payload?.payment_history_id) ||
        pick(payload?.paymentHistoryId) ||
        pick(payload?.data?.payment_history_id) ||
        pick(payload?.data?.paymentHistoryId) ||
        pick(payload?.payment_history?.id) ||
        pick(payload?.data?.payment_history?.id) ||
        pick(payload?.data?.id) ||
        pick(payload?.id);
      if (direct) return direct;

      // Deep scan only for payment_history_id-like keys (never payment_id / intent id).
      const stack = [payload];
      while (stack.length) {
        const node = stack.pop();
        if (!node || typeof node !== "object") continue;
        if (Array.isArray(node)) {
          node.forEach((item) => stack.push(item));
          continue;
        }
        const keys = Object.keys(node);
        for (const key of keys) {
          const value = node[key];
          const normalizedKey = String(key).toLowerCase();
          if (
            normalizedKey === "payment_history_id" ||
            normalizedKey === "paymenthistoryid" ||
            normalizedKey === "payment_historyid"
          ) {
            const found = pick(value);
            if (found) return found;
          }
          if (normalizedKey === "payment_history" && value && typeof value === "object") {
            const found = pick(value?.id);
            if (found) return found;
          }
          if (value && typeof value === "object") {
            stack.push(value);
          }
        }
      }
      return 0;
    },
    resetFieldErrors() {
      this.fieldErrors.address = "";
      this.fieldErrors.country = "";
      this.fieldErrors.state = "";
      this.fieldErrors.city = "";
      this.fieldErrors.zipCode = "";
      this.fieldErrors.first_name = "";
      this.fieldErrors.last_name = "";
      this.fieldErrors.email = "";
      this.fieldErrors.saved_card = "";
    },
    resolveDraftOrderIdForBackNavigation() {
      const fromState = String(this.draft_order_id || "").trim();
      if (fromState) return fromState;
      const fromStorage = String(localStorage.getItem("draft-order-id") || "").trim();
      if (fromStorage) return fromStorage;
      const links = Array.isArray(this.links) ? this.links : [];
      for (const link of links) {
        const fromLink = String(link?.draft_order_id || "").trim();
        if (fromLink) return fromLink;
      }
      return "";
    },
    syncOrderCacheForBackNavigation() {
      try {
        localStorage.setItem("order-title", this.summary?.order_title || "");
        if (this.draft_order_id) {
          localStorage.setItem("draft-order-id", this.draft_order_id);
        } else {
          localStorage.removeItem("draft-order-id");
        }
        localStorage.setItem(
          "links",
          LZString.compress(JSON.stringify(this.links || []))
        );
        localStorage.setItem("links-total", String(Number(this.link_total) || 0));
        localStorage.setItem("addons-count", String(Number(this.addon_count) || 0));
        localStorage.setItem("addons-total", String(Number(this.addon_total) || 0));
        localStorage.setItem("sub-total", String(Number(this.backend_sub_total) || 0));
        localStorage.setItem("order-total", String(Number(this.order_total) || 0));
        localStorage.setItem("discount", String(Number(this.discount) || 0));
        localStorage.setItem("couponCode", this.form?.couponCode || "");
      } catch {
        // Ignore cache write issues and still allow navigation.
      }
    },
    redirectToDraftListing(useReplace = false) {
      const restQuery = { ...(this.$route.query || {}) };
      delete restQuery.draft_checkout;
      delete restQuery.draft_ids;
      const route = { name: "draft-order", query: restQuery };
      if (useReplace) {
        this.$router.replace(route);
      } else {
        this.$router.push(route);
      }
    },
    isDraftCheckoutRoute() {
      return (
        this.draftCheckoutMode ||
        !!String(this.$route.query.draft_checkout || "").trim()
      );
    },
    goBackToOrder() {
      if (this.isDraftCheckoutRoute()) {
        this.redirectToDraftListing();
        return;
      }
      const resolvedDraftId = this.resolveDraftOrderIdForBackNavigation();
      if (resolvedDraftId) {
        this.draft_order_id = resolvedDraftId;
      }
      this.syncOrderCacheForBackNavigation();
      if (this.isMediaLinksSummaryFlow || localStorage.getItem("media_link") === "true") {
        const mediaDraftId = String(resolvedDraftId || this.draft_order_id || "").trim();
        this.$router.push({
          name: "media-links-summary",
          ...(mediaDraftId ? { params: { id: mediaDraftId } } : {}),
          query: this.$route.query || {},
        });
        return;
      }
      localStorage.setItem("from-order-summary-back", "1");
      const route = this.draft_order_id
        ? {
            name: "product",
            params: { id: this.draft_order_id },
            query: this.$route.query,
          }
        : {
            name: "product",
            query: this.$route.query,
          };
      this.$router.push(route);
    },
    redirectToProductIfNoLinks() {
      if (this.isDraftCheckoutRoute()) {
        this.redirectToDraftListing(true);
        return;
      }
      this.$router.replace({ name: "product", query: this.$route.query });
    },
    buildInvoiceCheckoutsMap(items) {
      const map = {};
      (items || []).forEach((item) => {
        if (!item || typeof item !== "object") return;
        if (item.type !== "draft_order" || !item.checkout || typeof item.checkout !== "object") {
          return;
        }
        const draftId = Number(item.draft_order_id || item.checkout.draft_order_id || 0);
        if (!draftId) return;
        map[draftId] = {
          ...item.checkout,
          draft_order_id: draftId,
          opportunity_id:
            item.checkout.opportunity_id ?? item.opportunity_id ?? null,
        };
      });
      return map;
    },
    getInvoiceDraftValidationError(source) {
      return (
        source?.response?.data?.message ||
        source?.response?.data?.error ||
        source?.message ||
        source?.error ||
        "This order does not exist"
      );
    },
    async validateDraftCheckoutBeforePay() {
      if (!this.draftCheckoutToken) {
        toast.error("Draft checkout is unavailable.", { timeout: 4000 });
        return false;
      }

      try {
        const res = await this.$store.dispatch("Product/validateDraftCheckoutAction", {
          draft_checkout: this.draftCheckoutToken,
        });
        if (!res?.success) {
          toast.error(this.getInvoiceDraftValidationError(res), { timeout: 4000 });
          return false;
        }
        return true;
      } catch (error) {
        toast.error(this.getInvoiceDraftValidationError(error), { timeout: 4000 });
        return false;
      }
    },
    async validateDraftOrderBeforePay() {
      if (this.draftCheckoutMode) {
        return true;
      }

      const draftOrderId = this.resolveDraftOrderIdForBackNavigation();
      if (!draftOrderId) {
        return true;
      }

      try {
        const res = await this.$store.dispatch("Product/validateDraftOrderAction", {
          draft_order_id: draftOrderId,
        });
        if (!res?.success) {
          toast.error(this.getInvoiceDraftValidationError(res), { timeout: 4000 });
          return false;
        }
        return true;
      } catch (error) {
        toast.error(this.getInvoiceDraftValidationError(error), { timeout: 4000 });
        return false;
      }
    },
    async loadDraftCheckout(draftCheckoutToken) {
      this.loading = true;
      try {
        const res = await this.$store.dispatch("Product/getDraftCheckoutPreviewAction", {
          draft_checkout: draftCheckoutToken,
        });
        const checkout = res?.checkout;
        if (!res?.success || !checkout || !Array.isArray(checkout.items) || !checkout.items.length) {
          toast.error(res?.message || "Draft checkout is unavailable.", { timeout: 4000 });
          this.draftCheckoutMode = false;
          this.draftCheckoutToken = "";
          return false;
        }

        this.draftCheckoutMode = true;
        this.draftCheckoutToken = draftCheckoutToken;
        this.draftCheckoutIds = (checkout.items || [])
          .map((item) => Number(item?.draft_order_id))
          .filter((id) => Number.isFinite(id) && id > 0);
        this.draftCheckoutItems = checkout.items;
        this.draftCheckouts = this.buildInvoiceCheckoutsMap(this.draftCheckoutItems);
        this.summary.order_title = "Order Summary";
        this.links = [];
        this.sub_total = Number(checkout.amount) || 0;
        this.backend_sub_total = this.sub_total;
        this.addon_total = 0;
        this.discount = 0;
        this.order_total = this.sub_total;
        return true;
      } catch (error) {
        toast.error(error?.response?.data?.message || "Unable to load draft checkout.", {
          timeout: 4000,
        });
        this.draftCheckoutMode = false;
        this.draftCheckoutToken = "";
        return false;
      } finally {
        this.loading = false;
      }
    },
    draftCheckoutPayload(extra = {}) {
      return {
        draft_checkout: this.draftCheckoutToken,
        address: this.form.address,
        country: this.form.country,
        city: this.form.city,
        state: this.form.state,
        zip_code: this.form.zipCode,
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        checkouts: this.draftCheckouts,
        ...extra,
      };
    },
    async confirmDraftCheckoutPayment(payload) {
      const idsFromState = (this.draftCheckoutIds || [])
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0);
      const idsFromItems = (this.draftCheckoutItems || [])
        .map((item) => Number(item?.draft_order_id))
        .filter((id) => Number.isFinite(id) && id > 0);
      const draftIds = idsFromState.length ? idsFromState : idsFromItems;

      let lastRes = null;
      let invoiceId = null;
      const idsToFulfill = draftIds.length ? draftIds : [null];

      for (const draftOrderId of idsToFulfill) {
        const chunkPayload = { ...payload };
        if (draftOrderId) {
          chunkPayload.draft_order_id = draftOrderId;
        }
        if (invoiceId) {
          chunkPayload.invoice_id = invoiceId;
        }

        lastRes = await this.$store.dispatch("Product/payDraftCheckoutAction", chunkPayload, {
          root: true,
        });
        if (!lastRes?.success) {
          throw new Error(lastRes?.message || "Unable to finalize payment.");
        }
        invoiceId = lastRes.invoice_id || invoiceId;
      }

      toast.success(
        payload?.method === "ach" ? this.achStartedMessage : lastRes?.message || "Order Added.",
        { timeout: payload?.method === "ach" ? 5000 : 3000 }
      );
      const restQuery = { ...(this.$route.query || {}) };
      delete restQuery.draft_ids;
      delete restQuery.draft_checkout;
      this.$router.push({ path: "/order", query: restQuery });
      return lastRes;
    },
    async payDraftCheckoutWithWallet() {
      if (!(await this.validateDraftCheckoutBeforePay())) {
        return;
      }

      try {
        this.loading = true;
        this.walletBox = true;
        await this.confirmDraftCheckoutPayment(
          this.draftCheckoutPayload({ method: "balance" })
        );
      } catch (e) {
        if (e?.response?.data?.status == 3) {
          toast.error("Insufficient Balance.", { timeout: 3000 });
        } else {
          toast.error(
            e?.response?.data?.message || e?.message || "Payment failed.",
            { timeout: 4000 }
          );
        }
      } finally {
        this.loading = false;
      }
    },
    pickAddon(link, addonLabel) {
      const needle = String(addonLabel || "").trim().toLowerCase();
      return (link?.addons || []).find((a) => {
        const n = String(a?.addon_name || a?.addonName || "").trim().toLowerCase();
        return n === needle;
      }) || null;
    },
    formatTrafficStability(name) {
      const n = String(name || "").toLowerCase();
      if (n.includes("6")) return "6mo";
      if (n.includes("12")) return "12mo";
      return name || "—";
    },
    formatLessThanAddonName(name) {
      const raw = String(name || "").trim();
      if (!raw) return "—";
      const normalized = raw.replace(/less\s*than/gi, "").trim();
      if (normalized.includes("<")) return normalized;
      return `< ${normalized}`;
    },
    getMetric(link) {
      return String(link?.product?.name || "").toUpperCase().startsWith("DR")
        ? "DR"
        : "DA";
    },
    getMediaSiteName(link) {
      if (link?.media_site) return link.media_site;
      const raw = String(link?.url || "").trim();
      if (!raw) return "—";
      return raw.replace(/^https?:\/\//i, "").split("/")[0] || raw;
    },
    getDestinationUrl(link) {
      const value =
        link?.destination_url ||
        link?.destinationUrl ||
        link?.url ||
        "";
      return String(value).trim() || "—";
    },
    formatMetricValue(link) {
      const raw = String(link?.product?.name || "").trim();
      if (!raw) return "—";
      return raw;
    },
    getLinkBasePrice(link) {
      if (link?.custom_price_check) {
        return Number(link?.custom_price ?? link?.custom_price_value ?? 0) || 0;
      }
      return Number(link?.primary_category?.total_cost ?? 0) || 0;
    },
    getLinkAddonsTotal(link) {
      return (link?.addons || []).reduce((sum, a) => sum + (Number(a?.cost) || 0), 0);
    },
    getLinkTotal(link) {
      return this.getLinkBasePrice(link) + this.getLinkAddonsTotal(link);
    },
    hydrateLinksOpenState() {
      // Keep collapse UX: first item open by default
      this.links = (this.links || []).map((l, idx) => ({
        ...l,
        isOpen: idx === 0,
      }));
    },
    getItems() {
      if (
        sessionStorage.getItem("payment-flow-type") === "edited" &&
        localStorage.getItem("editedOrder")
      ) {
        this.editedOrder = localStorage.getItem("editedOrder");
        this.order_total = localStorage.getItem("order-total");
        this.editedOrderId = localStorage.getItem("editedOrderId");
        this.newPrice = localStorage.getItem("new-price");
        this.oldPrice = localStorage.getItem("old-price");
        try {
          this.groupedLinks = JSON.parse(
            LZString.decompress(localStorage.getItem("grouped-links"))
          );
        } catch {
          this.groupedLinks = [];
        }
        this.editOrderPP = localStorage.getItem("edit-pp-order") === "true";
        try {
          this.linkIds = JSON.parse(
            LZString.decompress(localStorage.getItem("link-ids"))
          );
        } catch {
          this.linkIds = [];
        }
      } else {
        this.draft_order_id = localStorage.getItem("draft-order-id");
        this.summary.order_title = localStorage.getItem("order-title");
        try {
          this.links = JSON.parse(
            LZString.decompress(localStorage.getItem("links"))
          );
        } catch {
          this.links = [];
        }
        this.da_20_count = localStorage.getItem("da_20_count");
        this.da_20_total = localStorage.getItem("da_20_total");
        this.da_30_count = localStorage.getItem("da_30_count");
        this.da_30_total = localStorage.getItem("da_30_total");
        this.da_40_count = localStorage.getItem("da_40_count");
        this.da_40_total = localStorage.getItem("da_40_total");
        this.da_50_count = localStorage.getItem("da_50_count");
        this.da_50_total = localStorage.getItem("da_50_total");
        this.da_60_count = localStorage.getItem("da_60_count");
        this.da_60_total = localStorage.getItem("da_60_total");
        this.link_total = localStorage.getItem("links-total");
        this.addon_count = localStorage.getItem("addons-count");
        this.addon_total = localStorage.getItem("addons-total");
        this.sub_total = localStorage.getItem("sub-total");
        this.backend_sub_total = Number(this.sub_total) || 0;
        this.discount = localStorage.getItem("discount") ?? 0;
        this.order_total = localStorage.getItem("order-total");
        this.form.couponCode = localStorage.getItem("couponCode");
        try {
          this.opportunity_ids = JSON.parse(
            LZString.decompress(localStorage.getItem("selected-opportunity"))
          );
        } catch {
          this.opportunity_ids = null;
        }
        if (this.opportunity_ids) {
          this.opportunityOrder = true;
          try {
            this.summaryPaymentData = JSON.parse(
              LZString.decompress(localStorage.getItem("summary-data"))
            );
          } catch {
            this.summaryPaymentData = null;
          }
        }
        this.packageOrder = JSON.parse(localStorage.getItem("packageOrder"));
        this.packageName = localStorage.getItem("packageName");
        this.packageId = localStorage.getItem("packageId");
        this.packagePrice = localStorage.getItem("packagePrice");
        this.packageLinks = localStorage.getItem("packageLinks");
      }

      // Keep NewPaymentPage display logic requirement:
      // subtotal should represent links/base only.
      this.link_total = Number(this.link_total) || 0;
      this.addon_total = Number(this.addon_total) || 0;
      this.addon_count = Number(this.addon_count) || 0;
      this.discount = Number(this.discount) || 0;
      if (!this.backend_sub_total) {
        this.backend_sub_total = this.link_total + this.addon_total;
      }
      this.sub_total = this.link_total;
      this.order_total = this.backend_sub_total - this.discount;

      // Fallbacks if local storage values are empty
      if (!this.link_total && this.links?.length) {
        this.link_total = this.links.reduce((s, l) => s + this.getLinkBasePrice(l), 0);
        this.sub_total = this.link_total;
      }
      if (!this.addon_total && this.links?.length) {
        this.addon_total = this.links.reduce((s, l) => s + this.getLinkAddonsTotal(l), 0);
      }
      if (!this.addon_count && this.links?.length) {
        this.addon_count = this.links.reduce((s, l) => s + (l?.addons || []).length, 0);
      }
      if (!this.backend_sub_total) {
        this.backend_sub_total = this.link_total + this.addon_total;
      }
      this.order_total = this.backend_sub_total - this.discount;
      // this.hydrateLinksOpenState();
      this.syncMediaLinksFlowState();
    },
    syncMediaLinksFlowState() {
      const mediaFlag = localStorage.getItem("media_link") === "true";
      const links = Array.isArray(this.links) ? this.links : [];
      const hasMediaLinksShape = links.length > 0 && links.every((link) =>
        link?.website_id != null ||
        link?.media_placement_id != null ||
        link?.link?.media_placement_id != null ||
        String(link?.media_site || "").trim() !== "" ||
        String(link?.link?.media_site || "").trim() !== ""
      );
      this.isMediaLinksSummaryFlow = mediaFlag && hasMediaLinksShape;
      if (!this.isMediaLinksSummaryFlow) {
        localStorage.setItem("media_link", "false");
      }
    },
    async getReferralCouponCode() {
      try {
        const res = await this.$store.dispatch("Product/getReferralCouponAction");
        if (res?.success) {
          this.coupon = res.code;
          await this.applyCoupon("d");
        }
      } catch (error) {
        // Keep checkout usable if referral coupon cannot be applied.
      }
    },
    async applyCoupon(type) {
      try {
        this.errors["coupon"] = "";
        this.loading = true;

        const totals = {
          sub_total: {
            label: "Subtotal",
            value: Number(this.backend_sub_total) || 0,
          },
          total: {
            label: "Total",
            value: this.order_total,
          },
        };

        const res = await this.$store.dispatch(
          "Product/applyCouponAction",
          {
            cType: type,
            referral: this.referral,
            code: this.coupon,
            totals,
          },
          { root: true }
        );

        if (res?.success) {
          const appliedDiscount = Number(res?.discount) || 0;
          this.form.couponCode = this.coupon;
          this.discount = appliedDiscount;
          this.order_total = (Number(this.backend_sub_total) || 0) - (Number(this.discount) || 0);

          localStorage.setItem("couponCode", this.coupon);
          localStorage.setItem("discount", String(this.discount));
          localStorage.setItem("order-total", String(this.order_total));

          if (appliedDiscount > 0) {
            this.trackApplyCoupon();
          }
          this.coupon = "";
          toast.success(res.message || "Coupon applied", { timeout: 3000 });
        }
      } catch (error) {
        this.errors["coupon"] = error?.response?.data?.errors || "Invalid coupon code";
      } finally {
        this.loading = false;
      }
    },
    openPaymentReviewPanel() {
      this.showPaymentReviewPanel = true;
    },
    async proceedFromOrderReview() {
      this.showPaymentReviewPanel = false;
      await this.$nextTick();
      await this.initializeStripe();
      this.cardListFunction(1, false);
      this.trackAddPaymentInfo("visa");
    },
    loadStripeScript() {
      if (this.stripeScriptPromise) {
        return this.stripeScriptPromise;
      }
      this.stripeScriptPromise = new Promise((resolve, reject) => {
        const existing = document.getElementById("stripe-js");
        if (existing) {
          if (window.Stripe) {
            resolve(window.Stripe);
            return;
          }
          const onLoad = () => resolve(window.Stripe);
          const onError = () => reject(new Error("Failed to load Stripe script"));
          existing.addEventListener("load", onLoad, { once: true });
          existing.addEventListener("error", onError, { once: true });
          return;
        }
        const script = document.createElement("script");
        script.id = "stripe-js";
        script.src = "https://js.stripe.com/v3/";
        script.onload = () => resolve(window.Stripe);
        script.onerror = () => reject(new Error("Failed to load Stripe script"));
        document.head.appendChild(script);
      });
      return this.stripeScriptPromise;
    },
    async initializeStripe() {
      try {
        const StripeConstructor = await this.loadStripeScript();
        this.stripeElement = StripeConstructor(this.stripeKey);
        const elements = this.stripeElement.elements();
        const host = document.getElementById("card-element");
        if (!host) return;
        host.innerHTML = "";
        this.stripCard = elements.create("card", {
          style: { base: { fontSize: "16px", color: "#32325d" } },
          hidePostalCode: true,
        });
        this.stripCard.mount("#card-element");
        this.stripCard.on("change", (event) => {
          const displayError = document.getElementById("card-errors");
          if (displayError) displayError.textContent = event.error ? event.error.message : "";
        });
      } catch {
        // ignore mount failures
      }
    },
    async ensureStripeReady() {
      // Handles cases where card element wasn't mounted (e.g. tab toggles).
      if (!this.stripCard || !this.stripeElement) {
        await this.$nextTick();
        await this.initializeStripe();
      }
      return !!(this.stripCard && this.stripeElement);
    },
    loadScript() {
      const scriptExists = document.querySelector('script[src*="paypal.com/sdk/js"]');
      if (scriptExists) return;
      const paypalScript = document.createElement("script");
      paypalScript.setAttribute(
        "src",
        "https://www.paypal.com/sdk/js?client-id=" +
          this.paypal.sandbox +
          "&currency=USD&disable-funding=credit,card,sepa"
      );
      document.head.appendChild(paypalScript);
    },
    paypalOption() {
      if (window.paypal) {
        const vm = this;
        const container = document.getElementById("paypal-button-container");
        if (!container) return;

        // Prevent duplicate PayPal button mounts on tab switches.
        container.innerHTML = "";

        window.paypal
          .Buttons({
            style: {
              shape: "rect",
              color: "gold",
              layout: "vertical",
              label: "paypal",
              size: "responsive",
              tagline: "false",
            },
            createOrder: async (_data, actions) => {
              if (vm.draftCheckoutMode) {
                const valid = await vm.validateDraftCheckoutBeforePay();
                if (!valid) {
                  throw new Error(vm.getInvoiceDraftValidationError());
                }
              } else if (!(await vm.validateDraftOrderBeforePay())) {
                throw new Error(vm.getInvoiceDraftValidationError());
              }
              return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      value: Number(vm.payableTotal).toFixed(2),
                    },
                  },
                ],
              });
            },
            onApprove: (_data, actions) => {
              return actions.order.capture().then(async (orderData) => {
                const transaction =
                  orderData.purchase_units?.[0]?.payments?.captures?.[0];
                vm.payment_id = transaction?.id || "";
                if (vm.draftCheckoutMode) {
                  try {
                    vm.loading = true;
                    await vm.confirmDraftCheckoutPayment(
                      vm.draftCheckoutPayload({
                        method: "paypal",
                        payment_id: vm.payment_id,
                      })
                    );
                  } catch (e) {
                    toast.error(
                      e?.response?.data?.message || e.message || "PayPal payment failed.",
                      { timeout: 4000 }
                    );
                  } finally {
                    vm.loading = false;
                  }
                  return;
                }
                vm.addOrder();
              });
            },
            onCancel: () => {
              toast.error("PayPal payment cancelled.", { timeout: 3000 });
            },
            onError: (err) => {
              const msg = String(err?.message || "");
              if (msg.includes("This order does not exist")) {
                return;
              }
              toast.error("PayPal payment failed. Please try again.", {
                timeout: 4000,
              });
            },
          })
          .render("#paypal-button-container");
      }
    },
    validateBillingFields() {
      this.resetFieldErrors();
      let valid = true;
      if (!String(this.form.address || "").trim()) {
        this.fieldErrors.address = "Address is required.";
        valid = false;
      }
      if (!this.form.country) {
        this.fieldErrors.country = "Country is required.";
        valid = false;
      }
      if (!this.form.state) {
        this.fieldErrors.state = "State is required.";
        valid = false;
      }
      if (!String(this.form.city || "").trim()) {
        this.fieldErrors.city = "City is required.";
        valid = false;
      }
      if (!String(this.form.zipCode || "").trim()) {
        this.fieldErrors.zipCode = "Zip code is required.";
        valid = false;
      }
      return valid;
    },
    async beforeAchConfirm() {
      if (this.draftCheckoutMode && !(await this.validateDraftCheckoutBeforePay())) {
        return false;
      }
      return this.validateDraftOrderBeforePay();
    },
    async finalizeAchOrder(paymentIntent) {
      this.paymentIntent_id = paymentIntent?.id || "";
      this.cardLast4 = paymentIntent?.payment_method?.us_bank_account?.last4 || "";
      this.method = "ach";
      this.paymentOption = "ach";
      if (this.draftCheckoutMode) {
        await this.confirmDraftCheckoutPayment(
          this.draftCheckoutPayload({
            method: "ach",
            paymentIntentId: this.paymentIntent_id,
            last4: this.cardLast4,
            ach_discount: this.achDiscountAmount,
            coupon_discount: this.couponDiscountAmount,
            discount: this.combinedDiscount,
          })
        );
        return;
      }
      await this.addOrder();
    },
    async submitPayment() {
      if (this.payButtonDisabled) return;

      if (this.selectedPaymentMethod === "ach") {
        await this.submitAchPayment();
        return;
      }

      this.paying = true;
      await this.$nextTick();

      try {
        // Wallet payment does not require billing details validation.
        if (this.selectedPaymentMethod !== "wallet") {
          if (!this.validateBillingFields()) {
            toast.error("Please fill all billing address fields.", { timeout: 3000 });
            return;
          }
        }

        if (this.draftCheckoutMode && this.selectedPaymentMethod === "wallet") {
          if (this.showWalletInsufficient) {
            toast.error("Insufficient Balance.", { timeout: 3000 });
            return;
          }
          await this.payDraftCheckoutWithWallet();
          return;
        }

        if (this.selectedPaymentMethod === "card") {
          if (this.selectedCardTab === "new") {
            if (!String(this.form.first_name || "").trim()) {
              this.fieldErrors.first_name = "First name is required.";
            }
            if (!String(this.form.last_name || "").trim()) {
              this.fieldErrors.last_name = "Last name is required.";
            }
            if (this.fieldErrors.first_name || this.fieldErrors.last_name) {
              toast.error("Please enter card holder first and last name.", { timeout: 3000 });
              return;
            }
            await this.stripePaymentMethod();
            return;
          }
          if (this.selectedCardTab === "saved") {
            this.fieldErrors.saved_card = "";
            if (!this.selectedSavedCardId) {
              this.fieldErrors.saved_card = "Please select a card.";
              toast.error("Please select a card.", { timeout: 3000 });
              return;
            }
            await this.stripeSavePaymentMethod();
            return;
          }
        }

        if (this.selectedPaymentMethod === "wallet") {
          if (this.showWalletInsufficient) {
            toast.error("Insufficient Balance.", { timeout: 3000 });
            return;
          }
          if (!(await this.validateDraftOrderBeforePay())) {
            return;
          }
          await this.addOrder();
          return;
        }

        if (this.selectedPaymentMethod === "paypal" && !this.paypalShow) {
          this.cardListFunction(4);
        }
      } finally {
        this.paying = false;
      }
    },
    async stripePaymentMethod() {
      if (this.draftCheckoutMode && !(await this.validateDraftCheckoutBeforePay())) {
        return;
      }
      if (!(await this.validateDraftOrderBeforePay())) {
        return;
      }

      const ready = await this.ensureStripeReady();
      if (!ready) {
        toast.error("Card form is not ready yet.", { timeout: 3000 });
        return;
      }
      this.loading = true;
      const { paymentMethod, error } = await this.stripeElement.createPaymentMethod({
        type: "card",
        card: this.stripCard,
        billing_details: {
          name: `${this.form.first_name || ""} ${this.form.last_name || ""}`.trim(),
          address: {
            line1: this.form.address,
            city: this.form.city,
            state: this.form.state,
            postal_code: this.form.zipCode,
          },
        },
      });
      if (error) {
        this.loading = false;
        const displayError = document.getElementById("card-errors");
        if (displayError) displayError.textContent = error.message;
        toast.error(error.message, { timeout: 4000 });
        return;
      }
      try {
        const payload = {
          payment_method: paymentMethod.id,
          last4: paymentMethod.card.last4,
          amount: Number(this.payableTotal).toFixed(2),
          name: `${this.form.first_name || ""} ${this.form.last_name || ""}`.trim(),
          address: this.form.address,
          country: this.form.country,
          city: this.form.city,
          state: this.form.state,
          zip_code: this.form.zipCode,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
        };

        const responseData = await this.$store.dispatch(
          "Product/stripePaymentMethodAction",
          payload,
          { root: true }
        );
        this.paymentMethod_id = paymentMethod.id;
        this.cardLast4 = paymentMethod.card.last4;
        this.paymentIntent_id = responseData.id;
        this.paymentHistory_id = this.resolvePaymentHistoryId(responseData);
        await this.handlePayment(responseData);
      } catch (e) {
        this.loading = false;
        toast.error(e?.response?.data?.message || "Payment failed.", { timeout: 4000 });
      }
    },
    async stripeSavePaymentMethod() {
      if (this.draftCheckoutMode && !(await this.validateDraftCheckoutBeforePay())) {
        return;
      }
      if (!(await this.validateDraftOrderBeforePay())) {
        return;
      }

      this.fieldErrors.saved_card = "";
      if (!this.selectedSavedCardId && !this.card) {
        this.fieldErrors.saved_card = "Please select a saved card.";
        toast.error("Please select a saved card.", { timeout: 3000 });
        return;
      }

      const selectedCard = this.normalizedSavedCards.find(
        (card) => String(card.id) === String(this.selectedSavedCardId || this.card)
      );
      this.cardLast4 = selectedCard?.last4 || "";

      this.loading = true;
      try {
        const responseData = await this.$store.dispatch(
          "Product/stripeSavePaymentMethodAction",
          {
            amount: Number(this.payableTotal).toFixed(2),
            address: this.form.address,
            country: this.form.country,
            city: this.form.city,
            state: this.form.state,
            zip_code: this.form.zipCode,
            card: this.card || this.selectedSavedCardId,
          },
          { root: true }
        );
        this.paymentMethod_id = responseData.payment_method;
        this.paymentIntent_id = responseData.id;
        this.paymentHistory_id = this.resolvePaymentHistoryId(responseData);
        await this.handlePayment(responseData);
      } catch (e) {
        this.loading = false;
        this.fieldErrors.saved_card = "Unable to charge selected saved card.";
        toast.error(e?.response?.data?.message || "Payment failed.", { timeout: 4000 });
      }
    },
    async handlePayment(paymentIntent) {
      if (
        paymentIntent?.status === "requires_action" ||
        paymentIntent?.status === "requires_source_action"
      ) {
        const { error, paymentIntent: confirmed } =
          await this.stripeElement.confirmCardPayment(paymentIntent.client_secret);
        if (error) {
          this.loading = false;
          toast.error(error.message, { timeout: 4000 });
          return;
        }
        if (confirmed?.status === "succeeded") {
          if (this.draftCheckoutMode) {
            await this.finalizeDraftCheckoutPayment(confirmed);
          } else {
            await this.addOrder();
          }
        }
      } else if (paymentIntent?.status === "succeeded") {
        if (this.draftCheckoutMode) {
          await this.finalizeDraftCheckoutPayment(paymentIntent);
        } else {
          await this.addOrder();
        }
      }
    },
    async finalizeDraftCheckoutPayment(paymentIntent) {
      try {
        this.loading = true;
        await this.confirmDraftCheckoutPayment(
          this.draftCheckoutPayload({
            method: "stripe",
            paymentIntentId: paymentIntent.id,
            last4: this.cardLast4,
          })
        );
      } catch (e) {
        toast.error(e?.response?.data?.message || e.message || "Payment failed.", {
          timeout: 4000,
        });
      } finally {
        this.loading = false;
      }
    },
    async addOrder() {
      try {
        this.loading = true;
        const resolvedDraftOrderId = this.resolveDraftOrderIdForBackNavigation();
        if (resolvedDraftOrderId) {
          this.draft_order_id = resolvedDraftOrderId;
        }
        const allLinks = [];
        (this.links || []).forEach((link) => {
          const addon_total = (link.addons || []).reduce((s, a) => s + (Number(a?.cost) || 0), 0);
          let linkTotal = 0;
          if (this.packageOrder) {
            linkTotal = Number(this.packagePrice || 0) / Number(this.packageLinks || 1);
          } else if (link.custom_price_check) {
            linkTotal = Number(link.custom_price || 0);
          } else {
            linkTotal = Number(link?.primary_category?.total_cost || 0);
          }
          const payloadLink = {
            ...(link || {}),
            secondry_category: link?.secondry_category ?? "",
            // Keep keys intact but drop heavy nested collections for large orders.
            product: link?.product
              ? {
                  ...(link.product || {}),
                  addons: [],
                  categories: [],
                }
              : link?.product ?? null,
            metricProduct: link?.metricProduct
              ? {
                  ...(link.metricProduct || {}),
                  addons: [],
                  categories: [],
                }
              : link?.metricProduct ?? null,
            primary_category: link?.primary_category
              ? {
                  ...(link.primary_category || {}),
                  relevant_category_lists: [],
                }
              : link?.primary_category ?? null,
          };
          allLinks.push({
            id: link.id,
            product_id: link.product ? link.product.id : "",
            product_type: link.product_type || null,
            exact_da_dr: link.exact_da_dr || null,
            product_name: link.product ? link.product.name : "",
            link: payloadLink,
            link_total: linkTotal,
            addon_total,
            trialDA: link.trialDA,
            order_title: link.order_title,
            draft_order_id: this.draft_order_id,
            total: linkTotal,
            addon_cost: addon_total,
          });
        });

        const totals = {
          sub_total: { label: "Subtotal", value: Number(this.backend_sub_total) || 0 },
          total: { label: "Total", value: this.payableTotal },
        };
        if (this.couponDiscountAmount > 0 || this.achDiscountAmount > 0) {
          totals.discount = { label: "Discount", value: this.combinedDiscount };
        }

        const res = await this.$store.dispatch(
          "Product/addOrderAction",
          {
            links: allLinks,
            orderTitle: this.summary.order_title,
            totals,
            couponCode: this.form.couponCode,
            method: this.method,
            payment_id: this.payment_id,
            saveCard: this.saveCheck,
            existingCard: this.existingCard,
            card: this.card || this.selectedSavedCardId,
            first_name: this.form.first_name,
            last_name: this.form.last_name,
            card_number: this.form.cardNumber,
            expiration_month: this.form.cardMM,
            expiration_year: this.form.cardYY,
            cvv: this.form.cardCVC,
            address: this.form.address,
            country: this.form.country,
            state: this.form.state,
            city: this.form.city,
            zip_code: this.form.zipCode,
            order_medium: this.orderMedium,
            order_source: this.orderSource,
            order_campaign: this.orderCampaign,
            opportunity_id: this.opportunity_ids,
            opportunity: this.opportunityOrder,
            mediaLinks: this.isMediaLinksSummaryFlow,
            packageOrder: this.packageOrder,
            packageId: this.packageId,
            paymentIntentId: this.paymentIntent_id,
            paymentMethodId: this.paymentMethod_id,
            last4: this.cardLast4,
            draft_order_id: resolvedDraftOrderId || this.draft_order_id || null,
          },
          { root: true }
        );
        if (res?.success) {
          if (this.appStatus === "production") {
            try {
              this.mainProducts = JSON.parse(localStorage.getItem("main_products") || "{}");
              const id = res?.data?.id;
              if (id) this.ga4EventPurchase(id);
            } catch {
              // Keep checkout success flow resilient even if analytics payload is malformed.
            }
          }
          [
            "order-title",
            "links",
            "links-total",
            "addons-count",
            "addons-total",
            "sub-total",
            "order-total",
            "discount",
            "couponCode",
            "main_products",
            "opportunity-links",
            "selected-opportunity",
            "summary-data",
          ].forEach((k) => localStorage.removeItem(k));
          toast.success(
            this.method === "ach" ? this.achStartedMessage : res.message || "Order Added.",
            { timeout: this.method === "ach" ? 5000 : 3000 }
          );
          const restQuery = { ...(this.$route.query || {}) };
          delete restQuery.media_links_data;
          this.$router.push({ path: "/order", query: restQuery });
        }
      } catch (e) {
        if (e?.response?.data?.status == 3 && this.walletBox) {
          toast.error("Insufficient Balance.", { timeout: 3000 });
        } else if (e?.response?.data?.status == 2) {
          toast.error(e?.response?.data?.error || "This order does not exist.", { timeout: 3000 });
        } else {
          toast.error(e?.response?.data?.message || "Failed to place order.", { timeout: 3000 });
        }
      } finally {
        this.loading = false;
      }
    },
    async addMediaLinksOrder() {
      const resolvedDraftOrderId = this.resolveDraftOrderIdForBackNavigation();
      if (resolvedDraftOrderId) {
        this.draft_order_id = resolvedDraftOrderId;
      }
      const paymentHistoryId = Number(this.paymentHistory_id || 0);
      const paymentId = String(this.payment_id || "").trim();
      const paymentIntentId = String(this.paymentIntent_id || "").trim();
      const mediaProductMap = this.summary?.media_product_id_map || {};
      const toAuthorityValue = (value) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
      };
      const getMappedProductId = (authorityValue) => {
        if (authorityValue == null) return null;
        const key =
          authorityValue <= 20
            ? "da_20"
            : authorityValue <= 30
              ? "da_30"
              : authorityValue <= 40
                ? "da_40"
                : authorityValue <= 50
                  ? "da_50"
                  : "da_60";
        const mapped = Number(mediaProductMap?.[key] ?? 0);
        return mapped > 0 ? mapped : null;
      };
      if (!paymentHistoryId && !paymentId && !paymentIntentId) {
        toast.error("Payment reference not found. Unable to create media order.", { timeout: 4000 });
        return;
      }
      const allLinks = (this.links || [])
        .map((link) => {
          const mediaPlacementId = Number(
            link?.website_id || link?.media_placement_id || link?.id || 0
          );
          const exactDa = toAuthorityValue(
            link?.exact_da_dr ?? link?.authority ?? link?.da ?? link?.domain_authority
          );
          const productIdRaw = Number(
            link?.product_id ??
              link?.product?.id ??
              link?.mapped_product_id ??
              link?.da_product_id ??
              0
          );
          const mappedProductId = getMappedProductId(exactDa);
          const resolvedProductId = productIdRaw > 0 ? productIdRaw : mappedProductId;
          const destinationLink = String(
            link?.destination_url || link?.destinationUrl || link?.url || ""
          ).trim();
          const anchorText = String(link?.text || link?.anchor_text || "").trim();
          const linkTotal = Number(
            link?.link_total ??
              (link?.custom_price_check === true
                ? link?.custom_price
                : link?.primary_category?.total_cost) ??
              link?.total ??
              0
          );
          const payloadLink = {
            ...(link || {}),
            media_placement_id: mediaPlacementId,
            link_total: linkTotal,
            total: linkTotal,
            addons: Array.isArray(link?.addons) ? link.addons : [],
            destination_url: destinationLink || "",
            url: destinationLink || "",
            anchor_text: anchorText || "",
            text: anchorText || "",
            primary_category: {
              ...(link?.primary_category || {}),
              id: link?.primary_category?.id ?? link?.category_id ?? null,
            },
            secondry_category: link?.secondry_category ?? "",
            placement_url: link?.placement_url ?? "",
            order_title: link?.order_title || this.summary?.order_title || "Media Placement Order",
          };
          if (exactDa != null) {
            payloadLink.exact_da_dr = exactDa;
            payloadLink.exact_da = exactDa;
            payloadLink.authority = exactDa;
          }
          if (resolvedProductId > 0) {
            payloadLink.product_id = resolvedProductId;
            payloadLink.product = {
              ...(link?.product || {}),
              id: resolvedProductId,
              name: link?.product?.name || `DA ${exactDa || ""}`.trim(),
            };
          }
          return {
            id: link?.id ?? mediaPlacementId,
            product_id: payloadLink.product_id || "",
            product_type: payloadLink.product_type || null,
            exact_da_dr: payloadLink.exact_da_dr ?? null,
            product_name: payloadLink.product?.name || "",
            link: payloadLink,
            link_total: linkTotal,
            addon_total: 0,
            trialDA: payloadLink.trialDA ?? false,
            order_title: payloadLink.order_title,
            draft_order_id: this.draft_order_id,
            total: linkTotal,
            addon_cost: 0,
            media_placement_id: mediaPlacementId,
          };
        })
        .filter((item) => item.media_placement_id > 0);

      if (!allLinks.length) {
        toast.error("No valid media placement selected.", { timeout: 4000 });
        return;
      }
      const subtotalValue = Number(this.sub_total) || 0;
      const discountValue = Number(this.discount) || 0;
      const totalValue = Number(this.payableTotal) || 0;

      const payload = {
        // Tell backend this add-order request is media placement flow.
        order_type: "media_placement",
        is_media_placement: 1,
        media_link: true,
        orderTitle: this.summary?.order_title || "Media Placement Order",
        order_title: this.summary?.order_title || "Media Placement Order",
        // Keep add-order old structure: full links objects.
        links: allLinks,
        totals: {
          subtotal: { value: subtotalValue },
          discount: { value: discountValue },
          total: { value: totalValue },
        },
        order_medium: this.orderMedium,
        order_source: this.orderSource,
        order_campaign: this.orderCampaign,
        method: this.method,
        paymentMethodId: this.paymentMethod_id,
        payment_id: paymentId || undefined,
        paymentIntentId: paymentIntentId || undefined,
        payment_history_id: paymentHistoryId || undefined,
        first_name: String(this.form.first_name || "").trim(),
        last_name: String(this.form.last_name || "").trim(),
        address: String(this.form.address || "").trim(),
        city: String(this.form.city || "").trim(),
        state: this.form.state,
        country: this.form.country,
        zip_code: String(this.form.zipCode || "").trim(),
        draft_order_id: resolvedDraftOrderId || this.draft_order_id || null,
      };
      // Hard-ensure media markers exist exactly on top-level payload.
      payload.order_type = "media_placement";
      payload.is_media_placement = 1;
      payload.media_link = true;
      // Hard-ensure each link carries media_placement_id at both levels.
      payload.links = (payload.links || []).map((entry) => {
        const mediaPlacementId = Number(
          entry?.media_placement_id || entry?.link?.media_placement_id || 0
        );
        return {
          ...entry,
          media_placement_id: mediaPlacementId,
          link: {
            ...(entry?.link || {}),
            media_placement_id: mediaPlacementId,
          },
        };
      });

      // Final backend/frontend standard lock:
      // Stripe(card) -> paymentIntentId
      // PayPal -> payment_id
      if (this.selectedPaymentMethod === "paypal" && paymentId) {
        payload.payment_id = paymentId;
      } else if (paymentIntentId) {
        payload.paymentIntentId = paymentIntentId;
      } else if (paymentId) {
        // Safe fallback alias for PayPal-like reference.
        payload.payment_id = paymentId;
      } else if (paymentHistoryId) {
        // Backend supports payment history aliases as fallback.
        payload.payment_history_id = paymentHistoryId;
      }

      // Optional save-card contract for card checkout.
      if (this.selectedPaymentMethod === "card" && this.saveCheck === "save_card") {
        payload.saveCard = "save_card";
        payload.paymentMethodId = this.paymentMethod_id;
      } else {
        payload.saveCard = "no";
      }

      try {
        const res = await this.$store.dispatch("Product/addOrderAction", payload);
        if (res?.success) {
          [
            "order-title",
            "links",
            "links-total",
            "addons-count",
            "addons-total",
            "sub-total",
            "order-total",
            "discount",
            "couponCode",
            "media-placements-selected",
            "media_link",
          ].forEach((k) => localStorage.removeItem(k));
          toast.success(res.message || "Media placement order created.", { timeout: 3000 });
          const restQuery = { ...(this.$route.query || {}) };
          delete restQuery.media_links_data;
          this.$router.push({ path: "/order", query: restQuery });
        }
      } catch (e) {
        const fieldErrors = e?.response?.data?.errors;
        if (e?.response?.status === 422 && fieldErrors && typeof fieldErrors === "object") {
          const firstMessage = Object.values(fieldErrors)
            .flat()
            .find((msg) => typeof msg === "string" && msg.trim());
          toast.error(firstMessage || "Please review the highlighted fields and try again.", {
            timeout: 4000,
          });
          return;
        }
        toast.error(e?.response?.data?.message || "Failed to create media links order.", {
          timeout: 4000,
        });
      }
    },
    ga4EventPurchase(id) {
      const arr = [];
      let o_total = 0;
      let adn = 0;
      let cost = 0;
      let price = 0;
      let addon_count = 0;
      let quantity = 0;
      let unit_price = 0;

      Object.entries(this.mainProducts || {}).forEach(([key, val]) => {
        adn = Number(val?.addon_cost || 0);
        cost = Number(val?.link_cost || 0);
        price = cost + adn;
        addon_count = Number(val?.addon_count || 0);
        quantity = Number(val?.link_count || 0);
        unit_price = quantity > 0 ? (price / quantity) : 0;
        arr.push({
          id: val?.product_id || key,
          name: key,
          currency: "USD",
          addon: addon_count,
          price: Number(unit_price),
          quantity,
        });
      });

      o_total = Number(parseFloat(this.payableTotal).toFixed(2));

      this.pushAnalyticsUserId(this.$store.getters["Auth/getUser"]?.user_id);

      if (this.$gtag && typeof this.$gtag.purchase === "function") {
        this.$gtag.purchase({
          transaction_id: id,
          affiliation: "Link Building HQ",
          currency: "USD",
          value: o_total,
          items: arr,
        });
      }
    },
    trackAddPaymentInfo(paymentType) {
      if (this.appStatus !== "production") return;
      if (typeof window === "undefined") return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_payment_info",
        payment_type: String(paymentType || "").trim() || "unknown",
      });
    },
    trackApplyCoupon() {
      if (this.appStatus !== "production") return;
      if (typeof window === "undefined") return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "apply_coupon",
        coupon_action: "applied",
      });
    },
    cardFunction(card) {
      if (card == 2) {
        this.selectedCardTab = "saved";
        this.existingCard = "yes";
        this.saveCheck = "no";
        this.method = "save_card";
        if (this.selectedSavedCardId) {
          this.card = this.selectedSavedCardId;
          this.getSelectedCardDetail(this.card);
        }
      } else {
        this.selectedCardTab = "new";
        this.existingCard = "no";
        this.method = "new_card";
        this.$nextTick(() => {
          this.initializeStripe();
        });
      }
    },
    cardListFunction(num, shouldTrack = true) {
      if (num !== 5) {
        this.teardownAchElement();
      } else {
        this.releaseCardElement();
      }
      if (num == 1) {
        this.selectedPaymentMethod = "card";
        this.paymentOption = "card";
        this.paypalShow = false;
        this.detailBox = false;
        this.walletBox = false;
        this.payPalBox = false;
        if (shouldTrack) this.trackAddPaymentInfo("visa");
        if (this.existingCardList.length > 0) {
          this.cardFunction(2);
        } else {
          this.cardFunction(1);
        }
      } else if (num == 3) {
        this.selectedPaymentMethod = "wallet";
        this.paymentOption = "balance";
        this.paypalShow = false;
        this.detailBox = true;
        this.walletBox = true;
        this.payPalBox = false;
        this.existingCard = "no";
        this.method = "balance";
        if (shouldTrack) this.trackAddPaymentInfo("Wallet");
      } else if (num == 4) {
        this.selectedPaymentMethod = "paypal";
        this.paymentOption = "paypal";
        this.detailBox = true;
        this.walletBox = false;
        this.payPalBox = true;
        this.existingCard = "no";
        this.method = "paypal";
        this.paypalShow = true;
        if (shouldTrack) this.trackAddPaymentInfo("PayPal");
        this.$nextTick(() => this.paypalOption());
      } else if (num == 5) {
        this.selectedPaymentMethod = "ach";
        this.paymentOption = "ach";
        this.method = "ach";
        this.paypalShow = false;
        this.detailBox = true;
        this.walletBox = false;
        this.payPalBox = false;
        this.existingCard = "no";
        if (shouldTrack) this.trackAddPaymentInfo("ACH");
        this.$nextTick(() => this.initializeAchElement());
      }
    },
    async getCountries() {
      try {
        const res = await this.$store.dispatch("Product/getCountriesDataAction");
        this.countries = res?.countries || [];
      } catch {
        this.countries = [];
      }
    },
    async getStates(countryId) {
      if (!countryId) {
        this.states = [];
        this.form.state = null;
        return;
      }
      try {
        const res = await this.$store.dispatch("Product/getStatesDataAction", countryId);
        this.states = res?.states || [];
      } catch {
        this.states = [];
      }
    },
    async getExistingCards() {
      try {
        const res = await this.$store.dispatch("Product/getExistingCardsDataAction");
        let cards = [];
        if (Array.isArray(res)) {
          cards = res;
        } else if (Array.isArray(res?.cards)) {
          cards = res.cards;
        } else if (Array.isArray(res?.data)) {
          cards = res.data;
        } else if (res && typeof res === "object") {
          // Some APIs return keyed object instead of array
          cards = Object.values(res).filter((v) => v && typeof v === "object");
        }
        this.existingCardList = cards;
        if (this.existingCardList.length > 0) {
          this.selectedSavedCardId = null;
          this.card = "";
          // PaymentPage parity: when saved cards exist, show Saved Card by default.
          if (this.paymentOption === "card") {
            this.cardFunction(2);
          }
        } else if (this.paymentOption === "card") {
          this.cardFunction(1);
        }
      } catch {
        this.existingCardList = [];
      }
    },
    async getSelectedCardDetail(id) {
      if (!id) return;
      this.card = id;
      this.useProfileAddressChecked = false;
      this.loading = true;
      try {
        const res = await this.$store.dispatch("Product/getSelectedCardDataAction", id);
        this.form.address = res?.line1 || "";
        this.form.country = res?.country || null;
        if (this.form.country) {
          await this.getStates(this.form.country);
        }
        this.form.state = res?.state || null;
        this.form.city = res?.city || "";
        this.form.zipCode = res?.postal_code || "";
      } catch {
        // keep user entered values as is
      } finally {
        this.loading = false;
      }
    },
    async getProfileAddress() {
      if (this.useProfileAddressChecked) {
        this.loading = true;
        try {
          const res = await this.$store.dispatch("Profile/getProfileAddressDataAction");
          const ua = res?.user_address || {};
          this.form.address = ua.address || "";
          this.form.city = ua.city || "";
          this.form.country = ua.country != null ? ua.country : null;
          if (this.form.country) {
            await this.getStates(this.form.country);
            this.form.state = ua.state != null ? ua.state : null;
          } else {
            this.form.state = null;
          }
          this.form.zipCode = ua.postal_code || "";
        } catch {
          // ignore; leave fields as-is
        } finally {
          this.loading = false;
        }
      } else if (
        !this.useProfileAddressChecked &&
        this.method === "save_card" &&
        this.card
      ) {
        await this.getSelectedCardDetail(this.card);
      } else {
        this.loading = true;
        this.form.address = "";
        this.form.city = "";
        this.form.country = null;
        this.form.state = null;
        this.form.zipCode = "";
        this.loading = false;
      }
    },
    async showAddBalance() {
      try {
        await this.$store.dispatch("Auth/getUserDataAction");
      } catch {
        // ignore refresh errors
      }
    },
    toggleLink(id) {
      const clicked = this.links.find((link) => link.id === id);
      const willOpen = clicked ? !clicked.isOpen : true;

      this.links = this.links.map((link) => {
        if (link.id === id) {
          return { ...link, isOpen: willOpen };
        }
        // baaki sab band
        return { ...link, isOpen: false };
      });
    },
  },
  watch: {
    payableTotal() {
      if (this.selectedPaymentMethod === "ach") {
        this.initializeAchElement();
      }
    },
  },
  async mounted() {
    this.loading = true;
    // Keep normal and edited summary routes isolated.
    if (sessionStorage.getItem("payment-flow-type") === "edited") {
      this.$router.replace({ path: "/edited-order-summary", query: this.$route.query });
      return;
    }
    // Preload Stripe immediately on page entry so card element appears faster.
    this.loadStripeScript();
    this.orderSource = this.$route?.query?.source || this.$route?.query?.utm_source || "direct";
    this.orderMedium = this.$route?.query?.medium || this.$route?.query?.utm_medium || "direct";
    this.orderCampaign = this.$route?.query?.utm_campaign || "";
    this.isMediaLinksSummaryFlow = false;
    this.loadScript();

    const draftCheckoutToken = String(this.$route.query.draft_checkout || "").trim();
    if (draftCheckoutToken) {
      const loaded = await this.loadDraftCheckout(draftCheckoutToken);
      if (!loaded) {
        this.redirectToDraftListing(true);
        return;
      }
      const initTasks = [this.getCountries(), this.getExistingCards()];
      if (!this.showPaymentReviewPanel) {
        initTasks.push(this.initializeStripe());
      }
      await Promise.all(initTasks);
      if (await this.handleAchRedirectReturn()) {
        return;
      }
      if (!this.showPaymentReviewPanel) {
        this.cardListFunction(1, false);
      }
      this.loading = false;
      return;
    }

    this.getItems();
    if (!(this.links || []).length) {
      this.loading = false;
      this.redirectToProductIfNoLinks();
      return;
    }
    const isNormalProductOrder =
      sessionStorage.getItem("payment-flow-type") === "normal" &&
      !this.isMediaLinksSummaryFlow &&
      !this.opportunityOrder &&
      !this.packageOrder &&
      !this.editedOrder;
    if (
      isNormalProductOrder &&
      this.userData.referred_by &&
      this.userData.role === "Agency"
    ) {
      this.referral = true;
      await this.getReferralCouponCode();
      this.loading = true;
    }
    if (localStorage.getItem("order-summary-show-review") === "1") {
      localStorage.removeItem("order-summary-show-review");
      this.showPaymentReviewPanel = true;
    }
    const initTasks = [this.getCountries(), this.getExistingCards()];
    if (!this.showPaymentReviewPanel) {
      initTasks.push(this.initializeStripe());
    }
    await Promise.all(initTasks);
    if (await this.handleAchRedirectReturn()) {
      return;
    }
    if (!this.showPaymentReviewPanel) {
      this.cardListFunction(1, false);
      this.trackAddPaymentInfo("visa");
    }
    this.loading = false;
  }
};
</script>

<style scoped>
.inline-error {
  color: #d93025;
  font-size: 12px;
  margin-top: 6px;
}

/* Checkbox + text in one row; overrides .form-grid label { display:block } and input { width:100% } */
.new-payment-page-main-sec .billing-details .form-grid .profile-address-row label.save-card-checkbox {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
  cursor: pointer;
  font-size: 14px;
  color: #767676;
  font-weight: 400;
}

.new-payment-page-main-sec .billing-details .form-grid .profile-address-row label.save-card-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  min-width: 18px;
  margin: 0;
  flex-shrink: 0;
  cursor: pointer;
  padding: 0;
}

.new-payment-page-main-sec .billing-details .form-grid .profile-address-row label.save-card-checkbox span {
  user-select: none;
  line-height: 1.3;
}

.new-payment-page-main-sec .card-details-section .card-row .card-number-group-row {
  border: none !important;
  background: transparent !important;
}

.new-payment-page-main-sec .card-details-section .card-row .card-number-group-row .card-number-group {
  border: none !important;
  background: transparent !important;
}

.new-payment-page-main-sec .payment-method-section.no-billing {
  border-top: none !important;
  margin-top: 0 !important;
  padding-top: 0 !important;
}

#card-element {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

#card-element .StripeElement,
#card-element .__PrivateStripeElement,
#card-element iframe {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.invoice-meta-pill {
  display: inline-flex;
  align-items: center;
  margin-top: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #eef9fb;
  color: #007a8c;
  font-size: 13px;
  font-weight: 600;
}

.invoice-draft-summary-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.invoice-draft-summary-card {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  background: #fff;
}

.invoice-draft-summary-main {
  min-width: 0;

  .row-label {
    font-size: 12px;
    color: #767676;
    margin-bottom: 4px;
  }

  .row-value {
    font-size: 14px;
    font-weight: 600;
    color: #222;
    word-break: break-word;
  }
}

.invoice-draft-summary-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  white-space: nowrap;
  font-size: 13px;
  color: #767676;

  strong {
    font-size: 15px;
    color: #111;
  }
}

</style>
